// EntityTable.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import ExportsDialog from "./ExportsDialog";
import EntityUploadDialog from "./EntityUploadDialog";
import FiltersDialog from "./FiltersDialog";
import ColumnsDialog from "./ColumnsDialog";
import Card from "../Card/Card";
import Table from "../Table/Table";
import Dialog from "../Dialog/Dialog";
import DefaultTab from "../DefaultTab/DefaultTab";

import EditableForm from "../EditableForm/EditableForm";
import EntityDeleteDialog from "./EntityDeleteDialog";

import hasPermission from "../../../assets/files/hasPermission";

export default function EntityTableTemplate({ config, onSaved2 }) {
  const {
    title,
    entityLabel,
    idField,
    displayField,
    services,
    defaultFilters,
    attributes,
    conditions,
    formFields,
  } = config;

  const navigate = useNavigate();
  const { page } = useParams();
  const [navigation, setNavigation] = useState([]);

  const [collapsed, setCollapsed] = useState(false);
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);

  const [state, setState] = useState(null);
  const [entityToDelete, setEntityToDelete] = useState(null);
  const [formParams, setFormParams] = useState([{}]);

  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [UploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [columnsDialogOpen, setColumnsDialogOpen] = useState(false);

  const { ref } = useParams(); // get route param

  // ENTITY TABLE INITIALIZATION
  const [tableOptions, setTableOptions] = useState(() => {
    const filters = safeParse(localStorage.getItem(`filters_${title}`), defaultFilters);  
    const pageFromUrl = page ? Number(page) : 1;

    return {
      filters: filters,
      page: pageFromUrl,
      itemsPerPage: 10,
      sortBy: "",
      sortDesc: false,
    };
  });



  const [totalItems, setTotalItems] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const toggleCard = () => setCollapsed((p) => !p);

  const fetchNavigation = async (noId) => {
  if (!tableOptions.filters.length) {
    setNavigation([]);
    return;
  }

  try {
    const res = await services.nav(tableOptions.filters[0].value, noId);

    setNavigation(res.data.Navigation || []);
  } catch (err) {
    console.error("Navigation error", err);
    setNavigation([]);
  }
};


// ----------------------------
// INITIAL TAB & FILTER SETUP
// ----------------------------
useEffect(() => {
  if (!config.tabs || !config.tabs.length) return;
  const savedFilters = safeParse(localStorage.getItem(`filters_${title}`), []);
  
  // Find tab index that matches a subset of saved filters
  let initialTabIndex = 0;
  for (let i = 0; i < config.tabs.length; i++) {
    const tabFilters = config.tabs[i].filters || [];
    if (!tabFilters.length) continue;

    let allMatch = true;
    for (let j = 0; j < tabFilters.length; j++) {
      const tabFilter = tabFilters[j];
      const found = savedFilters.some(savedFilter =>
        tabFilter[0] === savedFilter[0] &&
        tabFilter[1] === savedFilter[1] &&
        tabFilter[2] === savedFilter[2] &&
        tabFilter[3] === savedFilter[3]
      );
      if (!found) {
        allMatch = false;
        break;
      }
    }

    if (allMatch) {
      initialTabIndex = i;
      break;
    }
  }

  setTabIndex(initialTabIndex);

  // Keep all saved filters, but ensure tab filters exist
  const tabFilters = config.tabs[initialTabIndex]?.filters || [];
  const filtersToApply = [...savedFilters];

  tabFilters.forEach(tf => {
    const exists = savedFilters.some(sf =>
      tf[0] === sf[0] &&
      tf[1] === sf[1] &&
      tf[2] === sf[2] &&
      tf[3] === sf[3]
    );
    if (!exists) filtersToApply.push(tf);
  });

  setTableOptions(prev => ({
    ...prev,
    filters: filtersToApply,
    page: 1,
  }));

  // Persist filters including any extra ones
  localStorage.setItem(`filters_${title}`, JSON.stringify(filtersToApply));

}, [config.tabs, title]);

// ----------------------------
// HANDLE TAB CHANGES
// ----------------------------
const handleTabChange = (index) => {
  setTabIndex(index);

  const tab = config.tabs[index];
  const filtersToApply = tab?.filters || [];

  setTableOptions(prev => ({
    ...prev,
    filters: filtersToApply,
    page: 1,
  }));

  // Persist filters
  localStorage.setItem(`filters_${title}`, JSON.stringify(filtersToApply));
};



  // =========================
  // FETCH (single source of truth)
  // =========================
  useEffect(() => {
    if (title === "Messages" && ref)
  tableOptions.filters =
    
       [
          {
            attribute: "ticket_id",
            condition: "==",
            value: ref,
            type: "str",
          },
        ];
    fetchEntities();
  // ----------------------------
  // INITIAL Navigation
  // ----------------------------


    tableOptions.page = page;
    if (title !== "Elements") return;

    const hierarchyFilter = tableOptions.filters.find(
      f => f.attribute === "parent_id" || f.attribute === "id"
    );

    if (!hierarchyFilter) {
      setNavigation([]);
      return;
    }

  fetchNavigation(hierarchyFilter.attribute === "parent_id");
  
  }, [tableOptions]);

  const fetchEntities = async () => {
    setLoading(true);
    onSaved2?.();
    try {
      const res = await services.list(tableOptions, services.services_url_names.list);
      setEntities(res.data.params || []);
      setTotalItems(res.data.total_count || 0);
    } catch (e) {
      console.error(e);
      setEntities([]);
    } finally {
      setLoading(false);
      if(title=="Messages")
        {
          setState("");
        }
    }
  };

  // =========================
  // FILTERS
  // =========================

  const applyFilters = (filters) => {
    setTableOptions((prev) => ({ ...prev, page: 1, filters:filters.filter(f => f != null) }));
    localStorage.setItem(`filters_${title}`, JSON.stringify(filters.filter(f => f != null)));
  };

  function safeParse(jsonString, defaultValue) {
  try {
    if (!jsonString) return defaultValue;
    return JSON.parse(jsonString);
  } catch (e) {
    //console.warn("Failed to parse JSON:", e, "Input:", jsonString);
    return defaultValue;
  }
}
  // =========================
  // COLUMNS
  // =========================
  const defaultColumns = attributes
  .filter((a) => a.is_default === "true")
  .map((a) => ({
    key: a.value,
    label: a.label,
    table_hidden:a?.table_hidden
  }));
  const [columns, setColumns] = useState(() => {
  const stored = localStorage.getItem(`columns_${title}`) || [];
  // fallback to defaultColumns
  const parsed = safeParse(stored, defaultColumns);

  return attributes
    .filter((attr) =>
      parsed.some((c) => c.key === attr.value)
    )
    .map((attr) =>
      parsed.find((c) => c.key === attr.value)
    );
});


  const updateColumns = (newColumns) => {
    setColumns(newColumns);
    localStorage.setItem(`columns_${title}`, JSON.stringify(newColumns));
  };


  const pushFilter = (field, value, type = "int") => {
    setTableOptions(prev => {
      const newFilter = {
        attribute: field,
        condition: "==",
        value,
        type,
      };

      let filters = [...prev.filters];
      //________________________
      if (field === "parent_id") {
        filters = filters.filter(f => f?.attribute !== "id");
      }

      else if (field === "id") {
        filters = filters.filter(f => f?.attribute !== "parent_id");
      }
      //_______________________
      const idx = filters.findIndex(f => f.attribute === field);

      if (idx !== -1) filters[idx] = newFilter;
      else filters.unshift(newFilter);

      localStorage.setItem(`filters_${title}`, JSON.stringify(filters));

      return { ...prev, filters, page: 1 };
    });
  };

  const actionContext = {
    navigate,
    pushFilter,
    refresh: fetchEntities,
    setState,
    setFormParams,
    setEntityToDelete,
  };

  const hasActiveFilters = tableOptions.filters.some(f =>
    !defaultFilters.some(df =>
      df.attribute === f.attribute &&
      df.condition === f.condition &&
      df.value === f.value
    )
  );

  return (
    <Card title={title === "Messages"
          ? `Ticket Ref : ${ref}`
          : title} collapsed={collapsed} toggleCard={toggleCard} showChevron>
      
      {/* Right-side actions */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {/* TABS (if defined) */}
        {config.tabs && (
          <div style={{ marginBottom: "8px" }}>
            {config.tabs.map((tab, idx) => (
              <DefaultTab
                key={idx}
                active={tabIndex === idx}
                onClick={() => handleTabChange(idx)}
              >
                {tab.label}
              </DefaultTab>
            ))}
          </div>
        )}

      {/* Vertical spacer */}
      <div style={{ height: "46px" }} />

      {config.title !=="Messages" && (
        <div>
          {/* ACTION BUTTONS */}
        
          {/* Export — only if defined */}
          {config.services?.export && hasPermission(config.rowActions?.find(a => a.key === "export")?.permission) && (
          <button className="default-btn" onClick={() => setExportDialogOpen(true)}>
            EXPORT
          </button>
          )}
          {/* Filters — only if defined */}
          {config.services?.filters && (
          <button
            className="default-btn"
            style={{
              backgroundColor: hasActiveFilters ? "orange" : "",
              color: hasActiveFilters ? "white" : "",
            }}
            onClick={() => setFilterDialogOpen(true)}
          >
            FILTERS
          </button>
          )}
          {/* Columns — only if defined */}
          {config.services?.columns && (
          <button
            className="default-btn"
            onClick={() => setColumnsDialogOpen(true)}
          >
            COLUMNS
          </button>
          )}
          {/* Upload — only if defined */}
          {config.services?.upload && hasPermission(config.rowActions?.find(a => a.key === "upload")?.permission) && (
            <button className="default-btn" onClick={() => setUploadDialogOpen(true)}>
              UPLOAD
            </button>
          )}

          {/* Create */}
          {config.services?.create && hasPermission(config.rowActions?.find(a => a.key === "edit")?.permission) &&(
            <button className="label-btn" onClick={() => {setFormParams([{}]);
                                                          setState("create");}}>
              CREATE {config.title}
            </button>
          )}
        </div>
      )}
      
    </div>
    {config.title !=="Messages" && (<>
      <div className="breadcrumb">
        {navigation.map((item, index) => {
          const [id, label] = item.split(" | ");

          return (
            <span key={index}>
              {" / "}
              <button
                className="breadcrumb-chip"
                onClick={() => {
                  tableOptions.filters=[];
                  pushFilter("parent_id", parseInt(id, 10));
                }}
              >
                {label}
              </button>
            </span>
          );
        })}
      </div>
    

      {/* Vertical spacer */}
      <div style={{ height: "16px" }} />


      {/* ACTIVE FILTER CHIPS */}
      <div style={{ margin: "12px 0" }}>
        {tableOptions.filters.map((f, i) => {
          let display = "";

          switch (f.condition) {
            case "start":
              display = `${f.attribute} starts with ${f.value}`;
              break;
            case "finish":
              display = `${f.attribute} finishes with ${f.value}`;
              break;
            case "in":
              display = `${f.value} in ${f.attribute}`;
              break;
            case "not in":
                display = `${f.value} not in ${f.attribute}`;
                break;
            default:
              display = `${f.attribute} ${f.condition} ${f.value}`;
          }

          return (
            <span key={i} className="chipStyle">
              {display}
              {!defaultFilters.some(df => 
                df.attribute === f.attribute &&
                df.condition === f.condition &&
                df.value === f.value
              ) && (
                <button className="label-btn chip"
                  onClick={() =>
                    applyFilters(tableOptions.filters.filter((_, idx) => idx !== i))
                  }
                >
                  ×
                </button>
              )}
            </span>
          );
        })}
    
      </div>
      </>
    )}  
      
      {/* TABLE */}
      <Table
        title={title}
        refParam={ref}
        columns={columns}
        data={entities}
        loading={loading}
        totalItems={totalItems}
        tableOptions={tableOptions}
        setTableOptions={setTableOptions}
        columnActions={config.columnActions || []}
        rowActions={config.rowActions || []}
        actionHandlers={config.actionHandlers || {}}
        actionContext={actionContext}
        hasPermission={hasPermission}
      />
      {config.title =="Messages" && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {/* Vertical spacer */}
          <div style={{ height: "16px" }} />

          {/* ACTION BUTTONS */}
          <div>
            <button className="label-btn">
              <Link to="/Tickets/1" className="btn-link">BACK</Link>
            </button>
            {/* Create */}
            {config.services?.create && (
              <button className="label-btn" onClick={() => {setFormParams([{}]);
                                                            setState("create");}}>
                POST REPLY
              </button>
            )}
          </div>
        </div>
      )}
        
      {/* DIALOGS */}
      <ExportsDialog
        open={exportDialogOpen}
        onClose={() => setExportDialogOpen(false)}
        services={config.services}
        tableOptions={tableOptions}
        entityLabel={entityLabel}
      />

      {<EntityUploadDialog
        open={UploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        uploadService={config.services}
        entityLabel={entityLabel}
      />}


      <FiltersDialog
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
        filters={tableOptions.filters}
        setFilters={applyFilters}
        attributes={attributes}
        conditions={conditions}
        defaultFilters={defaultFilters}
      />

      <ColumnsDialog
        open={columnsDialogOpen}
        onClose={() => setColumnsDialogOpen(false)}
        columns={columns}
        setColumns={updateColumns}
        attributes={attributes}
        title={title}
      />

      {/* EditableForm as create/edit dialog */} 
      <Dialog open={!!state} 
          onClose={() => {
          setState("");
          setState(null);
          setFormParams([{}]);
        }}>
          
        <EditableForm
          params={formParams}
          setParams={setFormParams}
          state={
            state == "create" ? "create" :
            state == "edit" ? "edit" :
            state == "info" ? "info" :
            state == "change_status" ? "change_status" :
            ""
          }
          title={title}
          showTitle={true}
          columns={formFields}
          services={config.services}       
          idField={idField}         
          refParam={ref}   
          onClose={(f) => {
            setState("");
            setState(null);
            setFormParams([{}]);
          }}
          onSaved={fetchEntities}
          saveButtonName={"Save"}
        />
      </Dialog>    

      <EntityDeleteDialog
        open={!!entityToDelete}
        entityLabel={entityLabel}
        displayValue={entityToDelete?.[displayField]}
        onClose={() => setEntityToDelete(null)}
        services={services}             
        idField={idField}    
        refParam={ref}             
        entity={entityToDelete}     
        onConfirm={fetchEntities}
      />
    </Card>
  );
}
